import { render } from "./cmcBills.vue?vue&type=template&id=fb49607a"
import script from "./cmcBills.vue?vue&type=script&lang=js"
export * from "./cmcBills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__